module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "logo-marque",
    attrs: {
      "data-name": "Logo Marque",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 15.59 19.76"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "d": "M7.8.5a7.37,7.37,0,0,1,7.3,7.43V19.26H.5V7.93A7.37,7.37,0,0,1,7.8.5"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-566d290c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LogoMarque.vue
// module id = 386
// module chunks = 1